<app-agent-breadcrumb
  [inAgentTwo]="inAgentTwo"
  [showUntil]="2"
  (navigateToAgentOne)="onNavigateBackToAgentOne()"
></app-agent-breadcrumb>

<div class="page-header home no-margin-left" *ngIf="!loadingAgentTwo">
  <h1 class="page-title">
    {{
      inAgentTwo
        ? "UK Chart of Account Mapping Agent"
        : "Trial Balance Extraction Agent"
    }}
  </h1>
  <p class="page-text margin">
    The Trial Balance Extraction Agent extracts and cleans trial balance data
    from client-provided Excel and exports the cleaned data in a format for the
    UK Chart of Account Mapping Agent, which then classifies accounts as either
    Income Statement or Balance Sheet item and constructs final mapping paths in
    a format compatible to Beehive.
  </p>
</div>

@if(loadingAgentTwo){
<div class="progressbar-container">
  <motif-progress-bar
    [circle]="true"
    [hideLabel]="true"
    [isIndeterminate]="true"
    [tabIndex]="0"
  ></motif-progress-bar>
</div>
} @if (surveyKey) {
<app-feedback [surveyKey]="surveyKey"></app-feedback>
}

<app-tb-instructions
  *ngIf="!inAgentTwo && !loadingAgentTwo"
></app-tb-instructions>

@if(!loadingAgentTwo){ @if(!inAgentTwo){
<div class="page-header">
  <h2 class="page-title">Trial Balance Extraction Workflow</h2>
  <p class="page-text"><!-- TODO --></p>
</div>
} @else {

<div
  class="top-downloaders-row"
  [ngClass]="{ 'is-zoomed': isZoomed, center: !coaMappedFileToDownload }"
>
  <div>
    <div class="page-header no-margin-left">
      <h2 class="page-title">Cleansed Trial Balance</h2>
    </div>

    <div class="chart-account-downloader-container">
      <app-custom-motif-downloader
        [filename]="chartOfAccountTBCleansedFile.filename"
        [fileId]="chartOfAccountTBCleansedFile.id"
        [fileSize]="chartOfAccountTBCleansedFile.file_size"
      ></app-custom-motif-downloader>
    </div>
  </div>

  @if (coaMappedFileToDownload) {
  <div>
    <div class="page-header no-margin-left">
      <h2 class="page-title">Latest Chart of Account Mapping</h2>
    </div>

    <div class="chart-account-downloader-container">
      <app-custom-motif-downloader
        [filename]="coaMappedFileToDownload.filename!"
        [fileId]="coaMappedFileToDownload.id!"
        [fileSize]="coaMappedFileToDownload.file_size!"
      ></app-custom-motif-downloader>
    </div>
  </div>
  }
</div>

<app-coa-instructions
  *ngIf="inAgentTwo && !loadingAgentTwo"
></app-coa-instructions>

<div class="page-header">
  <p class="page-title">Chart of Account Mapping</p>

  <div class="chart-account-form-container">
    <form [formGroup]="coaBeehiveForm">
      <div class="motif-theme-light">
        <label motifLabel class="select-label" for="beehive-select"
          >Select Beehive chart of accounts template</label
        >
        <motif-select
          #beehiveSelect
          [tabindex]="0"
          id="beehive-select"
          formControlName="selectedCoABeehive"
          [value]="selectedCoAOption"
          [required]="true"
          placeholder="Select Chart of Account"
          (selectionChanged)="onChartMappingType($event, beehiveSelect)"
        >
          @for(option of chartOfAccountDropdownMappings; track $index){
          <motif-select-option [value]="option.id">
            {{ option.name }}
          </motif-select-option>
          }
        </motif-select>
      </div>
    </form>
  </div>
</div>
} }

<div>
<!-- This can be a component -->
<div class="upload-progress-container" *ngIf="!loadingAgentTwo">
  <motif-progress-indicator orientation="horizontal" variant="row" hide-icon="false" size="sm">
    @for (step of steps; track $index) {
    <motif-progress-indicator-step
      [heading]="step.title"
      [status]="step.status"
      [disabled]="false"
      size="sm"
      [clickable]="true"
    ></motif-progress-indicator-step>
    }
  </motif-progress-indicator>

  @if (currentStep === 1) { @if(!runLoading){
  <app-custom-motif-uploader
    [file]="fileToRun"
    (fileEmitter)="onFileSelected($event)"
    (fileHasError)="onFileHasError($event)"
  ></app-custom-motif-uploader>
  } @if(runLoading){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [value]="runProgress"
      [hideLabel]="true"
      [isIndeterminate]="true"
      [tabIndex]="0"
    ></motif-progress-bar>
    <p progressbar-label>Trial Balance Key Column Selection in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelTrialBalanceRun()"
      (keydown.enter)="cancelTrialBalanceRun()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <motif-button
      variant="primary"
      (click)="runTrialBalance()"
      [disabled]="!fileToRun || fileToRunHasError || runLoading"
    >
      Run
    </motif-button>

    <!--  -->
    <motif-dropdown class="motif-dropdown-div" [tabIndex]="0">
      <motif-dropdown-trigger>
        <div class="dropdown-trigger-container">
          <motif-button
            class="text-button-in-dropdown"
            variant="primary"
            [disabled]="lastRunButtonDisabled"
            [tabIndex]="-1"
          >
            Continue with last run
          </motif-button>
          <button
            class="dropdown-toggle-button"
            [disabled]="lastRunButtonDisabled || runLoading"
            [ngClass]="{ disabled: lastRunButtonDisabled || runLoading }"
            [tabIndex]="-1"
          >
            <motif-icon
              class="icono-dropdown"
              size="18"
              [iconFunction]="IconoirNavArrowDown"
            ></motif-icon>
          </button>
        </div>
      </motif-dropdown-trigger>

      <motif-dropdown-content class="motif-theme-light">
        <motif-dropdown-item (click)="goToAgentOneLastRun()">
          Trial Balance Extraction Agent
        </motif-dropdown-item>

        <motif-dropdown-item
          [disabled]="agentTwoLastRunDisabled"
          (click)="agentTwoLastRunDisabled ? false : goToAgentTwoLastRun()"
        >
          UK Chart of Account Mapping Agent
        </motif-dropdown-item>
      </motif-dropdown-content>
    </motif-dropdown>
    <!--  -->
  </div>

  } @if(currentStep === 2){ @if(!runColumnCleansing){
  <div class="process-message-container" *ngIf="stepOneDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepOneDuration }}</p>
  </div>

  <div class="file-info-container">
    <p>File: {{ fileToRun?.name || this.savedTBFile?.filename }}</p>
    <p>
      Uploaded on:
      {{ tbeUploadedOn + "Z" | date : "MMM d, y h:mm a" }}
    </p>
  </div>

  <div class="form-fields-container">
    @for(dropdown of columnsDropdowns; let dropdownIndex = $index; track
    $index){
    <div class="motif-theme-light">
      <label
        motifLabel
        class="select-label"
        [attr.id]="'dropdown-label-' + $index"
        [for]="'dropdown' + $index"
        >{{ dropdown.label }}</label
      >
      <motif-select
        #columnSelect
        [tabindex]="0"
        [id]="'dropdown-' + $index"
        [ngClass]="{ 'greyed-out': dropdown.greyedOut }"
        [value]="dropdown.selectedId"
        [required]="false"
        (click)="onDropdownClick(dropdown)"
        (selectionChanged)="onSelectionChange($event, dropdownIndex)"
      >
        @for(option of dropdownOptions[dropdownIndex]; track $index){
        <motif-select-option [value]="option.id">{{
          option.displayName
        }}</motif-select-option>
        }
      </motif-select>
    </div>
    }
  </div>

  <app-table-view [data]="uploadedFileViewData"></app-table-view>

  } @if(runColumnCleansing){
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [hideLabel]="true"
      [isIndeterminate]="true"
      [tabIndex]="0"
    ></motif-progress-bar>
    <p progressbar-label>Trial Balance cleansing in progress...</p>

    <p
      class="cancel-run"
      [tabIndex]="0"
      (click)="cancelTrialBalanceColumnsMock()"
      (keydown.enter)="cancelTrialBalanceColumnsMock()"
    >
      Cancel
    </p>
  </div>
  }

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      [disabled]="runColumnCleansing"
      (click)="goToPreviousStep(true)"
    >
      Go back
    </motif-button>
    <motif-button
      variant="primary"
      [disabled]="runColumnCleansing"
      (click)="confirmAndCleanData()"
    >
      Confirm and clean data
    </motif-button>
  </div>

  } @if(currentStep === 3){
  <div class="process-message-container" *ngIf="stepTwoDuration">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ stepTwoDuration }}</p>
  </div>

  <div class="file-info-container">
    <p>File: {{ fileToRun?.name || this.savedTBFile?.filename }}</p>
    <p>
      Uploaded on:
      {{ tbeUploadedOn + "Z" | date : "MMM d, y h:mm a" }}
    </p>
  </div>

  <app-custom-motif-downloader
    [filename]="tbCleansedFile.filename"
    [fileId]="tbCleansedFile.id"
    [fileSize]="tbCleansedFile.file_size"
  ></app-custom-motif-downloader>

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      (click)="goToPreviousStep(true)"
    >
      Go back
    </motif-button>
    <motif-button
      variant="primary"
      (click)="goToNextStep(true)"
    >
      Continue
    </motif-button>
  </div>
  } @if(currentStep === 4){
  <app-custom-motif-uploader
    [file]="correctedTBFile"
    [dropMessage]="'Optionally, Click to upload or drag and drop'"
    (fileEmitter)="onCorrectedTrialBalanceUploaded($event)"
    (fileHasError)="onCorrectedTrialBalanceFileHasError($event)"
  ></app-custom-motif-uploader>

  <div class="buttons-container">
    <motif-button
      variant="primary-alt"
      (click)="goToPreviousStep(true)"
    >
      Go back
    </motif-button>
    <motif-button
      variant="primary"
      (click)="completeTrialBalanceProject()"
    >
      <motif-icon
        [iconFunction]="IconoirArrowRight"
        class="home-icon"
        style="color: #a4a6b8"
      ></motif-icon>
      {{ correctedTBFile ? "Upload and Continue" : "Skip and Continue" }}
    </motif-button>
  </div>
  }

  <!-- Agent two steps -->
  <!-- TODO: Optimize namings -->
  <!-- THIS -->
  <app-coa-agent
    *ngIf="inAgentTwo"
    [currentStep]="currentStep"
    [steps]="steps"
    [trialBalanceReportId]="trialBalanceReportId"
    [selectedCoAOption]="selectedCoAOption"
    [coaMappingFile]="coaMappingFile"
    [savedCoaMappingFile]="savedCoaMappingFile"
    [coaFinalMappingFile]="coaFinalMappingFile"
    [coaMappedFileToDownload]="coaMappedFileToDownload"
    [coaFinalMappedFileToDownload]="coaFinalMappedFileToDownload"
    [coaSummary]="coaSummary"
    [stepFiveDuration]="stepFiveDuration"
    [stepSevenDuration]="stepSevenDuration"
    [toUndoStep4]="toUndoStep4"
    (goToPreviousStepEmitter)="goToPreviousStep($event)"
    (goToNextStepEmitter)="goToNextStep($event)"
    (goBackToAgentOneAfterUndoEmitter)="goBackToAgentOneAfterUndo()"
    (coaSummaryEmitter)="setCoaSummary($event)"
    (coaMappedFileToDownloadEmitter)="setcoaMappedFileToDownload($event)"
  ></app-coa-agent>
</div>
<!-- END Component -->

<div class="bg-image" *ngIf="!loadingAgentTwo">
  @if(currentStep === 3) {
  <app-tb-agent-summary
    [cleansingSummary]="cleansingSummary"
  ></app-tb-agent-summary>
  } @if(currentStep === 8) {
  <app-chart-account-summary
    [coaSummary]="coaSummary"
  ></app-chart-account-summary>
  }

  <div class="buttons-container">
    <div class="left">
      <motif-button
        variant="primary-alt"
        (click)="backHome()"
      >
        <motif-icon
          [iconFunction]="IconoirHome"
          class="home-icon"
          style="color: #a4a6b8"
        ></motif-icon>
        Home
      </motif-button>
      <motif-button
        variant="primary-alt"
        (click)="scrollUp()"
      >
        Back to top
      </motif-button>
    </div>
  </div>
</div>
  <app-disclaimer></app-disclaimer>
</div>
